const CANCELLED_BOX_REFILL_RETENTION = {
  EXPERIMENT_NAME: 'canceled_box_refills_retention',
  OFF: 'off',
  CONTROL: 'control',
  VARIATION_A: 'variation_a',
  FEATURE_FLAG: 'canceled_box_refills_retention',
};

export { CANCELLED_BOX_REFILL_RETENTION };
